import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useParams } from 'react-router';
import ProjectGallery from '../ProjectGallery/ProjectGallery';
// import LoadingSkeleton from '../../../../Components/LoadingSkeleton/LoadingSkeleton';


const ProjectGallerys = () => {
    const [projects, setProjects] = useState([]);
    const { id } = useParams();
    // const [loading, setLoading] = useState(false);
    useEffect(() => {
        // setLoading(true)
        fetch(`https://firestore.googleapis.com/v1/projects/database-adminlogin/databases/(default)/documents/ourProjects/${id}/projectGallery/`)
            .then((res) => res.json())
            .then((data) => setProjects(data));
        // setLoading(false)
    }, [id]

    )
    console.log(projects)
    return (
        <>
            <div className='topBar'>
                <Navbar expand="lg" fixed="top" className="nav" style={{ background: "#272727" }} >

                    <div className='navContainer '>

                        <>
                            <Navbar.Brand className='ms-3'>
                                <Nav.Link href="/">

                                    <img width={75} src="https://webredox.net/demo/wp/bauen/light/el/multi/demo1/wp-content/uploads/2021/09/logo.png" alt="" />
                                </Nav.Link>

                            </Navbar.Brand>

                        </>


                    </div>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className="" >
                        <Nav className="ms-auto">
                            <Nav.Link href="/" className="navLink">Home</Nav.Link>
                        </Nav>
                        <Nav >
                            <Nav.Link href="/#about" className="navLink">About Us</Nav.Link>
                        </Nav>
                        <Nav className="">
                            <Nav.Link href="/#projects" className="navLink">Projects</Nav.Link>
                        </Nav>
                        <Nav className="">
                            <Nav.Link href="/#onGoingProjects" className="navLink">On Going Projects</Nav.Link>
                        </Nav>
                        <Nav className="">
                            <Nav.Link href="/#services" className="navLink">Services</Nav.Link>
                        </Nav>
                        <Nav className="">
                            <Nav.Link href="/#team" className="navLink">Our Team</Nav.Link>
                        </Nav>
                        <Nav className="" style={{ marginRight: "75px" }}>
                            <Nav.Link href="/#contact" className="navLink">Contact Us</Nav.Link>
                        </Nav>

                    </Navbar.Collapse>
                </Navbar>
            </div>
            <div className='home-projects-container'>
                <div className='container-fluid' >

                    <>
                        <div className="">
                            <ProjectGallery key={projects?.projects?.fields?.id?.stringValue} projects={projects} />

                        </div>
                    </>

                </div>
            </div>
        </>
    );
};

export default ProjectGallerys;